import { useHttpClient } from './httpClient.js';

const resource = 'prizes';

export function fetchPrizes() {
	return useHttpClient().get(`/${resource}`);
}

export function updatePrizes(form) {
	return useHttpClient().put(`/${resource}`, { prizesForm: form });
}
